import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import type {
  TeamingReason,
  TeamingReasonKeys,
} from 'features/teaming/teaming-base/enums';
import type { SelectItem } from 'features/ui/elements';
import { Select } from 'features/ui/elements';

interface SelectTeamingReasonProps {
  className?: string;
  value: TeamingReasonKeys;
  onChange: (event: TeamingReason) => void;
  options: SelectItem[];
}

export const SelectTeamingReason: FC<SelectTeamingReasonProps> = (props) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'selectTeamingReason',
  });

  return (
    <Select
      {...props}
      placeholder={t('placeholder')}
      onChange={(event) => props.onChange(event.target.value as TeamingReason)}
    />
  );
};
